import React, { useState, useEffect } from 'react';
import { getTranslation, detectLanguage } from './i18n';
import Header from './components/Header';
import TabBar from './components/TabBar';
import Generator from './components/Generator';
import ImportExport from './components/ImportExport';
import Guide from './components/Guide';
import PrivacyModal from './components/PrivacyModal';
import bgImage from './assets/background.jpg';
import bgImageRp from './assets/wow-rp.webp';

function App() {
  const [lang, setLang] = useState(detectLanguage());
  const [activeTab, setActiveTab] = useState('generator');
  const [bgIndex, setBgIndex] = useState(0);
  const [privacyOpen, setPrivacyOpen] = useState(false);
  const t = getTranslation(lang);

  // Alle 5 Sekunden zwischen den beiden Wallpapern hin- und herfaden
  useEffect(() => {
    const id = setInterval(() => setBgIndex(i => (i + 1) % 2), 5000);
    return () => clearInterval(id);
  }, []);

  const tabs = [
    { key: 'generator', label: t.tabs.generator },
    { key: 'importExport', label: t.tabs.importExport },
    { key: 'guide', label: t.tabs.guide },
  ];

  return (
    <div className="app-container">
      <div className="app-bg" style={{ backgroundImage: `url(${bgImage})`, opacity: bgIndex === 0 ? 1 : 0 }} />
      <div className="app-bg" style={{ backgroundImage: `url(${bgImageRp})`, opacity: bgIndex === 1 ? 1 : 0 }} />
      <div className="app-bg-fade" />

      <Header t={t} lang={lang} setLang={setLang} />

      <div className="app-main">
        <div className="wow-frame">
          <div className="wow-frame-content">
            <TabBar tabs={tabs} activeTab={activeTab} setActiveTab={setActiveTab} />
            {activeTab === 'generator' && <Generator t={t.generator} lang={lang} />}
            {activeTab === 'importExport' && <ImportExport t={t.importExport} />}
            {activeTab === 'guide' && <Guide t={t.guide} />}
          </div>
        </div>
      </div>

      <div style={{ background: 'rgba(0,0,0,0.6)', padding: '20px 16px', textAlign: 'center', marginTop: '16px', position: 'relative', zIndex: 1 }}>
        <div style={{ marginBottom: '10px', fontSize: '15px' }}>
          <a href="https://www.office1.cloud/" target="_blank" rel="noopener noreferrer" style={{ color: '#fff', textDecoration: 'none' }}>Office Cloud for Freelancers</a>
          <span style={{ margin: '0 12px', color: '#666' }}>|</span>
          <a href="https://www.playlisteditor.com/" target="_blank" rel="noopener noreferrer" style={{ color: '#fff', textDecoration: 'none' }}>M3u Playlist Editor with TV Android App</a>
          <span style={{ margin: '0 12px', color: '#666' }}>|</span>
          <a href="https://shop.peppertools.de" target="_blank" rel="noopener noreferrer" style={{ color: '#fff', textDecoration: 'none' }}>PepperTools Shop</a>
          <span style={{ margin: '0 12px', color: '#666' }}>|</span>
          <a href="https://www.peppertools.de/de/impressum/" target="_blank" rel="noopener noreferrer" style={{ color: '#fff', textDecoration: 'none' }}>{lang === 'de' ? 'Impressum' : 'Imprint'}</a>
          <span style={{ margin: '0 12px', color: '#666' }}>|</span>
          <a href="#" onClick={(e) => { e.preventDefault(); setPrivacyOpen(true); }} style={{ color: '#fff', textDecoration: 'none', cursor: 'pointer' }}>{lang === 'de' ? 'Datenschutz' : 'Privacy'}</a>
        </div>
        <div style={{ color: 'var(--wow-text-muted)', fontSize: '12px' }}>{t.footer}</div>
      </div>

      <PrivacyModal open={privacyOpen} onClose={() => setPrivacyOpen(false)} />
    </div>
  );
}

export default App;
